export default "__VITE_ASSET__CqFXiQys__"